import { Switch } from 'components/ui/switch';
import React from 'react';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';

interface Props {
    enabled: boolean;
    onChange: (enabled: boolean) => void;
    disabled?: boolean;
}

const TotalsToggle: React.FC<Props> = ({ enabled, onChange, disabled = false }) => (
    <label
        className={cn(
            'flex items-center text-sm whitespace-nowrap select-none',
            disabled ? 'text-fg-disabled cursor-not-allowed' : 'cursor-pointer'
        )}
    >
        {/* The text keeps a 6px margin and the switch 8px on every side, which spaces them 14px apart. */}
        <span className="m-1.5">{t('totals.show-totals')}</span>
        <Switch className="m-2" checked={enabled} onCheckedChange={onChange} disabled={disabled} />
    </label>
);

export default TotalsToggle;
